module.exports = __webpack_public_path__ + "img/h-facebook.c675371f.svg";